import React, { Fragment } from 'react'
import { isWebView } from '../../../admin/actions/index'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import isIn from 'validator/lib/isIn'
import Cookies from '../../../components/cookies'
import { getUrlParameter } from '../events/helpers'
import Landing from '../../../components/landing'
import Navbar from '../../../components/nav'
import Footer from '../../../components/footer'
import { withRouterConnectWrapper } from '../../../validator'
import SFNHeader from '../../../components/sfn/header'
import SFNFooter from '../../../components/sfn/footer'
import BaseApp from './base-app'

const ErrorIcon = '/images/danger-icon.svg'

class App extends BaseApp {
    constructor(props) {
        super(props)

        this.state = {
            sendError: this.sendError,
            errorMessage: null,
            showError: false,
            viewFullContentPages: [
                '/sign-up',
                '/forgotten-password',
                '/chat',
                '/events',
                '/camps',
                '/entities',
                '/sport-venues',
                '/clubs',
                '/contact',
                '/password/reset/:token',
                '/users/:userSlug',
                '/users/:userSlug/photos',
                '/news',
                '/news/:actuality',
                '/login',
                '/changelog',
                '/fanousek-sportovec',
                '/turnaje',
                '/trener',
                '/rodice-a-deti',
                '/pridat-sportoviste',
                '/o-nas',
                '/proc-sportnect',
                '/mesta',
                '/media',
                '/terms-and-conditions',
                '/faq',
                '/seznam-udalosti',
                '/seznam-klubu',
                '/seznam-sportovist',
                '/seznam-novinek',
                '/sportuji',
                '/mlady-sportovec',
                '/trener-instruktor-lektor',
                '/trenuji-tym-klub',
                '/organizuji-sportovni-akce',
                '/fandim-sportu',
                '/vlastnim-obchod',
                '/spravuji-sportoviste',
                '/seznam-funkci',
                '/top-udalosti',
                '/top-udalosti/udalosti',
                '/pro-sportujici/udalosti',
                '/pro-sportujici/kluby',
                '/pro-deti',
                '/pro-deti/udalosti',
                '/pro-deti/kluby',
                '/pro-divaky',
                '/pro-divaky/udalosti',
                '/jsem-organizator',
                '/chci-byt-informovan',
                '/pro-sportujici',
                '/shared-sports:friendshipId',
                '/timeline',
            ],
        }
    }

    static childContextTypes = {
        webview: PropTypes.bool,
        isMobile: PropTypes.bool,
    }

    getChildContext() {
        return {
            webview: isWebView(),
            isMobile: isWebView(),
        }
    }

    /**
     * Send error message handler
     *
     * @param {string} message
     */
    sendError = message => {
        this.setState({ errorMessage: message })
        process.nextTick(() => {
            this.setState({ showError: true })
            setTimeout(() => {
                this.setState({ showError: false })
            }, 5000)
        })
    }

    /**
     * Render error messages if is error message available
     *
     * @returns {XML|null}
     */
    renderErrorMessage = () => {
        if (this.state.errorMessage !== null) {
            return (
                <div
                    className={classnames({
                        'Alert-msg__error': true,
                        'Alert-msg__error-show': this.state.showError,
                    })}
                    key={4}
                >
                    <div className="Alert-msg__error-content">
                        <img src={ErrorIcon} alt="Error ikona" />
                        {this.state.errorMessage}
                    </div>
                </div>
            )
        }
        return null
    }

    /**
     * Check if is possible render whole page without a login
     *
     * @returns {*}
     */
    canRenderWholePageUnlogged = () => {
        if (this.props.login.forceLoginPage) {
            return false
        }

        const availablePages = JSON.parse(this.config.REACT_APP_AVAILABLE_UNLOGGED_SHOW)
        const params = this.props.match.params

        if (params && typeof params === 'object' && Object.keys(params).length > 0) {
            return Object.keys(params).some(param => isIn(param, availablePages))
        }

        return false
    }

    /**
     * Check if is new Sportnect login page
     *
     * @returns {boolean}
     */
    isSportnectLoginPage = () => this.props.match.path === '/login'

    /**
     * Render whole web with all resources
     *
     * @returns {XML}
     */
    renderFullWeb = () => {
        const isWebV = isWebView()
        const isSnLoginPage = this.isSportnectLoginPage()
        const {
            footerClass,
            hideFooter,
        } = this.props

        return (
            <Fragment>
                {!isWebV && !isSnLoginPage && <Navbar />}

                <div className="d-flex flex-column flex-fill min-h-65vh">
                    {React.Children.map(this.props.children, child => (
                        React.cloneElement(child, { ...this.state })
                    ))}
                </div>

                {!isWebV && !isSnLoginPage && !hideFooter && <Footer footerClass={footerClass} />}

                {this.renderErrorMessage()}
                {!isWebV && <Cookies />}
            </Fragment>
        )
    }

    /**
     * Render whole web with all resources
     *
     * @returns {XML}
     */
    renderSimpleFootballPage = () => {
        const isWebV = isWebView()

        const { sfNetwork } = this.props

        return (
            <Fragment>
                <SFNHeader />

                <div className={classnames({
                    'd-flex flex-column flex-fill min-h-65vh': true,
                    'position-relative': sfNetwork,
                })}>
                    {React.Children.map(this.props.children, child => (
                        React.cloneElement(child, { ...this.state })
                    ))}
                </div>

                <SFNFooter />

                {this.renderErrorMessage()}
                {!isWebV && <Cookies />}
            </Fragment>
        )
    }


    render() {
        const {
            token,
            authedUser,
            auth,
            showNavAndFooter,
            match: {
                path: path,
            },
            sfNetwork,
        } = this.props

        // show smartsupp again on other pages
        const smartsupp = document.getElementById('chat-application')

        if (smartsupp && !isWebView()) {
            smartsupp.style.display = 'block'
        }

        if (isIn(path, this.state.viewFullContentPages.map(page => `${page}`)) || this.canRenderWholePageUnlogged()) {
            return this.renderFullWeb()
        }

        if (sfNetwork || this.isSfnProfile(authedUser)) {
            return this.renderSimpleFootballPage()
        }

        if (!token && !auth.storeTokens && !getUrlParameter('access_token', this.props)) {
            return <Landing showNavAndFooter={showNavAndFooter} />
        }

        if (!authedUser) {
            return null
        }

        return this.renderFullWeb()
    }
}

export default withRouterConnectWrapper(state => ({
    authedUser: state.auth.user,
    token: state.auth.tokens ? state.auth.tokens.access_token : null,
    login: state.app.login,
    auth: state.auth,
}))(App)
